import useEdgeQuery from '@app/data/edge/hooks/useEdgeQuery';
import { useUserIsLoggedIn } from '@app/user';
import GET_DISCOUNT_CODES from '../queries/GetDiscountCodes';
import type { DiscountCode } from '../types';

interface DiscountCodesResponse {
  viewer: {
    discountCodes: {
      edges: {
        node: DiscountCode;
      }[];
    };
  };
}

/**
 * Get Discount codes for an user from edge layer
 */
const useDiscountCodes = ({ enabled = true } = {}) => {
  const loggedIn = useUserIsLoggedIn();

  const { data, loading, error } = useEdgeQuery<DiscountCodesResponse>(
    GET_DISCOUNT_CODES,
    {
      enabled: enabled && loggedIn,
    },
  );

  return {
    loading,
    error,
    data: data?.viewer?.discountCodes?.edges?.map(({ node }) => node) || [],
  };
};

export default useDiscountCodes;
